import { DaumPostcodeResponse } from '@gooduncles/gu-app-schema';
import { Drawer } from 'antd';
import { FC, useEffect, useState } from 'react';

// Daum Postcode API 타입 정의
interface DaumPostcodeOptions {
  onsearch?: (data: { q: string; count: number }) => void;
  oncomplete?: (data: DaumPostcodeResponse) => void;
  width?: string;
  height?: string;
  autoClose?: boolean;
}

interface DaumPostcode {
  embed: (element: HTMLElement, options?: { q: string }) => void;
}

interface DaumPostcodeConstructor {
  new (options: DaumPostcodeOptions): DaumPostcode;
}

interface WindowWithDaum extends Window {
  daum?: {
    Postcode: DaumPostcodeConstructor;
  };
}

const daum = (window as WindowWithDaum).daum;

interface DaumPostcodeModalProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onComplete: (data: DaumPostcodeResponse) => void;
}

const DaumPostcodeModal: FC<DaumPostcodeModalProps> = ({ visible, setVisible, onComplete }) => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [modalRef, setModalRef] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (daum && modalRef && visible) {
      const postcode = new daum.Postcode({
        onsearch: (data: { q: string; count: number }) => {
          setSearchKeyword(data.q);
        },
        oncomplete: (data: DaumPostcodeResponse) => {
          onComplete(data);
          setVisible(false);
        },
        width: '100%',
        height: '100%',
        autoClose: false,
      });

      postcode.embed(modalRef, searchKeyword ? { q: searchKeyword } : undefined);
    }

    // searchKeyword 변경에 따른 초기화를 막기 위함.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalRef, onComplete, setVisible, visible]);

  return (
    <Drawer
      title='주소검색'
      open={visible}
      placement='bottom'
      width='100%'
      height='100vh'
      keyboard={true}
      bodyStyle={{ padding: '12px 0 0 0' }}
      onClose={() => setVisible(false)}>
      <div ref={setModalRef} style={{ height: '100%' }} />
    </Drawer>
  );
};

export default DaumPostcodeModal;
